import type { HistoryActionType } from '@trello/action-history';
import type {
  ActionSubjectIdType,
  ActionType,
  SourceType,
} from '@trello/atlassian-analytics';
import { Analytics } from '@trello/atlassian-analytics';

const actionTypeToActionSubjectId: {
  [type in HistoryActionType]?: ActionSubjectIdType;
} = {
  join: 'joinCardAction',
  leave: 'leaveCardAction',
  'add-member': 'addMemberToCardAction',
  'remove-member': 'removeMemberFromCardAction',
  move: 'moveCardAction',
  'add-label': 'addLabelToCardAction',
  'remove-label': 'removeLabelFromCardAction',
  archive: 'archiveCardAction',
  unarchive: 'unarchiveCardAction',
  'set-dates': 'setCardDatesAction',
  rename: 'renameCardAction',
  'update-description': 'updateCardDescriptionAction',
};

interface Props {
  analyticsAction: ActionType;
  actionType: HistoryActionType;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  card: any;
  source: SourceType;
}

export function trackLastAction({
  analyticsAction,
  actionType,
  card,
  source,
}: Props): void {
  Analytics.sendTrackEvent({
    action: analyticsAction,
    actionSubject: 'action',
    actionSubjectId: actionTypeToActionSubjectId[actionType],
    source,
    containers: {
      board: { id: card.get('idBoard') },
      card: { id: card.id },
    },
  });
}
